import { Contenido } from './Contenido';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { SeccionFormulario } from './SeccionFormulario';
import { AlaFormulario } from './AlaFormulario';
import { ContenidoPlano } from 'interiores-mapa';
import { SeccionPlano } from 'interiores-mapa';
import { Constantes } from './constantes';

export class HistoricoLocalizacionContenido {
	Id: string;
	Contenido_Id: string;
	Contenido: Contenido; // OJO: Este es el contenido a mostrar pero con los datos actuales
	Elemento: string;
	Descripcion: string;
	Tipologias: string;

	Seccion: string; // Nombre de la seccion
	Ala: string; // Nombre del Ala
	Nivel: string; // Nombre del Nivel
	Localizacion: string; // Para filtro en tabla localizacion

	FechaDesde: Date;
	FechaHasta: Date;

	ENTIDAD: any;

	// Al mostrarlo en Historicos tendremos que usar los datos siguientes que son los correspondientes a la fecha del historico
	contenidoPlano: ContenidoPlano;
	X: number;
	Y: number;

	Ala_Id: String; // Id
	Nivel_Id: String; // Id
	Nodo_Id: String; // Id
	Seccion_Id: String; // Id

	AlaFormulario: AlaFormulario;
	SeccionFormulario: SeccionFormulario;

	// Campos para selector dropdown
	value: string;
	label: string;

	// Para pintar plano
	pathPlano: any;
	zoomLevels: any[];

	seccionPlano: any;

	tipologiaSeccion: string;

	constructor(){
		this.Id = '';
		this.Elemento = '';
		this.Descripcion = '';
		this.Tipologias = '';
		this.Seccion = '';
		this.FechaDesde = new Date();
		this.FechaHasta = new Date();
	}

	fromENTIDAD(ENTIDAD: any): HistoricoLocalizacionContenido{

		this.Id = ENTIDAD.Id;
		this.Elemento = ENTIDAD.Nombre;
		this.Descripcion  = '';
		this.Tipologias = '';
		this.FechaDesde = ENTIDAD.FechaDesde;
		this.FechaHasta = ENTIDAD.FechaHasta;
		this.Seccion = '';
		this.X = ENTIDAD.X;
		this.Y = ENTIDAD.Y;

		this.Contenido_Id = ENTIDAD.Contenido_Id;
		this.Ala_Id =  ENTIDAD.Ala_Id;
		this.Nivel_Id =  ENTIDAD.Nivel_Id;
		this.Nodo_Id =  ENTIDAD.Nodo_Id;
		this.Seccion_Id =  ENTIDAD.Seccion_Id;

		this.value = ENTIDAD.Contenido_Id;
		this.label = ENTIDAD.Nombre;
		//this.tipologiaSeccion = ENTIDAD.SeccionFormulario.TIPOLOGIAS_SECCION[0].Nombre;

		return this;
	}

	serializarLite(){
		const h = {
			Id: this.Id,
			Elemento: this.Elemento,
			Descripcion: this.Descripcion,
			Tipologias: this.Tipologias,
			FechaDesde: this.FechaDesde,
			FechaHasta	: this.FechaHasta,
			//Seccion: this.Seccion,
			X	: this.X,
			Y	: this.Y,

			Contenido_Id: this.Contenido_Id,
			Ala_Id: this.Ala_Id,
			Nivel_Id: this.Nivel_Id,
			Nodo_Id: this.Nodo_Id,
			Seccion_Id: this.Seccion_Id,

			value: this.value,
			label: this.label
		}

		const cadenaHistoricos = JSON.stringify(h);
		return cadenaHistoricos;
	}

	rellenarContenido(cont: Contenido, sec: any, ala: AlaFormulario){
		this.Contenido_Id = cont.Id;
		this.Contenido = cont;
		this.Tipologias = this.Contenido.Tipo;
		this.Elemento = this.Contenido.Titulo;
		this.Descripcion = this.Contenido.Descripcion;



		if (sec) {
			this.SeccionFormulario = new SeccionFormulario().fromENTIDAD(sec);
			this.Seccion = sec.Nombre;
			this.Ala = sec.ALA.Nomobre; // Nombre del Ala
			this.Nivel = sec.ALA.NIVEL.Nombre; // Nombre del Nivel
			this.Localizacion = this.Ala + ' ' + this.Nivel + ' ' + this.Seccion; // Para filtro en tabla localizacion
		}

		if (ala) {
			this.AlaFormulario = new AlaFormulario(ala);
			if (ala.RutaImagen){
				this.pathPlano = ala.RutaImagen;
			}
			if (ala.zoomMinimo && ala.zoomMaximo){
				this.zoomLevels = [ala.zoomMinimo , ala.zoomMaximo];
			}
		}

	}

	setHistoricoPuntoPlano(numeroContenido){
		let contenidoPlano;
		const punto = 'assets/planos/puntos/point_icon-' + numeroContenido + '.svg';
		// const punto = 'assets/planos/point_icon.svg';
		contenidoPlano = new ContenidoPlano(this.Contenido_Id, this.Elemento, this.X, this.Y, punto, [], this.AlaFormulario.IconoContenidoScale * 2);
		contenidoPlano.ENTIDAD = this.Contenido.ENTIDAD;

			// Icono visible
				contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
				contenidoPlano.symbolFill = Constantes.contenidoSymbolFill;
				contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
				contenidoPlano.symbolSize = Constantes.contenidoSymbolSize;
				contenidoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
				contenidoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
				contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
				contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
				contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
				contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);
				contenidoPlano.setIconAlign('center-center');

			// Posicionamos label aunque no se valla a ver
				const width =  parseInt(Constantes.contenidoIconWidth, 0);
				contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
				contenidoPlano.setLabelXoffset(10 + (width / 2));
				contenidoPlano.setLabelYoffset(-30);

			// Label no Visible
				contenidoPlano.setLabel(''); // Label desde BD
				contenidoPlano.setLabelColor('');
				contenidoPlano.setLabelFontFamily('');
				contenidoPlano.setLabelFontSize('');

			this.contenidoPlano = contenidoPlano;

	}

	setHistoricoPlano(orden, numeroContenido = 0) {
		try {

			// TODO: Cambiar con que valores se genera
			let contenidoPlano;
			let contenidoPuntoPlano;
			const numero = orden < 10 ? '0' + orden : '' + orden;
			let icono;
			if(Number(numero) > 99){
				 icono = 'assets/planos/Chinchetas_destinos/' + numeroContenido + '/destino-00.svg';
			}
			else{
				 icono = 'assets/planos/Chinchetas_destinos/' + numeroContenido + '/destino-' + numero + '.svg';
			}
			//const icono = 'assets/planos/Chinchetas_destinos/' + numeroContenido + '/destino-' + numero + '.svg';
			const punto = 'assets/planos/dot-inside-a-circle_icon-icons.com_70195.svg';
			contenidoPlano = new ContenidoPlano(this.Contenido_Id, this.Elemento, this.X, this.Y, icono, [], this.AlaFormulario.IconoContenidoScale * 2);
			contenidoPuntoPlano = new ContenidoPlano(this.Contenido_Id, this.Elemento, this.X, this.Y, punto, [], this.AlaFormulario.IconoContenidoScale * 2);

			contenidoPlano.ENTIDAD = this.Contenido.ENTIDAD;
			contenidoPuntoPlano.ENTIDAD = this.Contenido.ENTIDAD;
			// Icono visible
				contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
				contenidoPlano.symbolFill = Constantes.contenidoSymbolFill;
				contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
				contenidoPlano.symbolSize = Constantes.contenidoSymbolSize;
				contenidoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
				contenidoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
				contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
				contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
				contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
				contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);
				contenidoPlano.setIconAlign('bottom-center');

				contenidoPuntoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
				contenidoPuntoPlano.symbolFill = Constantes.contenidoSymbolFill;
				contenidoPuntoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
				contenidoPuntoPlano.symbolSize = Constantes.contenidoSymbolSize;
				contenidoPuntoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
				contenidoPuntoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
				contenidoPuntoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
				contenidoPuntoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
				contenidoPuntoPlano.setIconHeight(Constantes.contenidoIconHeight);
				contenidoPuntoPlano.setIconWidth(Constantes.contenidoIconWidth);
				contenidoPuntoPlano.setIconAlign('bottom-center');
			// Posicionamos label aunque no se valla a ver
				const width =  parseInt(Constantes.contenidoIconWidth, 0);
				contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
				contenidoPlano.setLabelXoffset(10 + (width / 2));
				contenidoPlano.setLabelYoffset(-30);

			// Label no Visible
				contenidoPlano.setLabel(''); // Label desde BD
				contenidoPlano.setLabelColor('');
				contenidoPlano.setLabelFontFamily('');
				contenidoPlano.setLabelFontSize('');

			this.contenidoPlano = contenidoPlano;
		}
		catch (ex) {
			console.error(ex);
		}
	}

	setHistoricoSeccionPlano(orden, numeroContenido = 0){
		try {

			// TODO: Cambiar con que valores se genera
			let seccionPlano;
			const numero = orden < 10 ? '0' + orden : '' + orden;
			let icono;

			if(Number(numero) > 99){
				 icono = 'assets/planos/Chinchetas_destinos/' + numeroContenido + '/destino-00.svg';
			}
			else{
				 icono = 'assets/planos/Chinchetas_destinos/' + numeroContenido + '/destino-' + numero + '.svg';
			}

			const punto = 'assets/planos/dot-inside-a-circle_icon-icons.com_70195.svg';
			var json = JSON.parse(this.SeccionFormulario.ENTIDAD.CoordenadasPoligono);
			seccionPlano = new SeccionPlano(this.SeccionFormulario.Id,this.SeccionFormulario.Nombre, json, 1, 1); this.SeccionFormulario.SECCION_PLANO;

			// Creamos el color
			var color = this.seccion_rgba(numeroContenido)
			seccionPlano.fill  = color;		// Reposo
			seccionPlano.hoverFill = color;	// Hover
			// Arista Seccion
			seccionPlano.stroke = color;					// Reposo
			seccionPlano.hoverStroke = color;	// Hover
			// Ancho
			seccionPlano.strokeWidth = color;

			this.seccionPlano = seccionPlano;
		}
		catch (ex) {
			console.error(ex);
		}
	}

	setHistoricoSeccionPuntoPlano(indiceColor){
		try {

			// TODO: Cambiar con que valores se genera
			let seccionPlano;
			var json = JSON.parse(this.SeccionFormulario.ENTIDAD.CoordenadasPoligono);
			seccionPlano = new SeccionPlano(this.SeccionFormulario.Id,this.SeccionFormulario.Nombre, json, 1, 1); this.SeccionFormulario.SECCION_PLANO;

			// Creamos el color
			var color = this.seccion_rgba(indiceColor)
			seccionPlano.fill  = color;		// Reposo
			seccionPlano.hoverFill = color;	// Hover
			// Arista Seccion
			seccionPlano.stroke = color;					// Reposo
			seccionPlano.hoverStroke = color;	// Hover
			// Ancho
			seccionPlano.strokeWidth = color;

			this.seccionPlano = seccionPlano;
		}
		catch (ex) {
			console.error(ex);
		}
	}

	seccion_rgba(number) {


		if (number == 1) {
			return Constantes.Red;
		}
		if (number == 2) {
			return Constantes.Maroon;
		}
		if (number == 3) {
			return Constantes.Yellow;
		}
		if (number == 4) {
			return Constantes.Olive;
		}
		if (number == 5) {
			return Constantes.Lime;
		}
		if (number == 6) {
			return Constantes.Green;
		}
		if (number == 7) {
			return Constantes.Aqua;
		}
		if (number == 8) {
			return Constantes.Teal;
		}
		if (number == 9) {
			return Constantes.Blue;
		}
		if (number == 10) {
			return Constantes.Navy;
		}
		if (number == 11) {
			return Constantes.Fuchsia;
		}
		if (number == 12) {
			return Constantes.Purple;
		}
		if (number == 13) {
			return Constantes.White;
		}
		if (number == 14) {
			return Constantes.Silver;
		}
		if (number == 15) {
			return Constantes.Black;
		}
		if (number == 16) {
			return Constantes.LightBlue;
		}
		if (number == 17) {
			return Constantes.LightBlue2;
		}
		return Constantes.Lime;

	}

	hexToRGB(hex: string, alpha: string) {

		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);

		if (alpha) {
		  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
		} else {
		  return `rgb(${r}, ${g}, ${b})`;
		}
	  }

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/HistoricoLocalizacionContenido.ts